export const CirclePlaceholderDashed = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.7082 10.0001C17.7082 14.2573 14.257 17.7084 9.99984 17.7084C5.74264 17.7084 2.2915 14.2573 2.2915 10.0001C2.2915 5.74289 5.74264 2.29175 9.99984 2.29175C14.257 2.29175 17.7082 5.74289 17.7082 10.0001Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="3 4"
    />
  </svg>
)

export default CirclePlaceholderDashed
